import React from 'react';
import styles from './ShowPreview.module.scss';
import { buildAdditionalParametersPreviewRows, buildAdditionalParametersRows } from './index';

const ShowAdditionalParametersPreview = ({
  calculationType,
  additionalSettings,
  previousAdditionalSettings = null,
}) => {
  const data = buildAdditionalParametersRows(additionalSettings);
  const previousData = previousAdditionalSettings
    ? buildAdditionalParametersRows(previousAdditionalSettings)
    : null;
  const showOldValueColumn = previousData != null;

  const rowsToRender = buildAdditionalParametersPreviewRows(data, previousData, calculationType);

  return (
    <div className={styles.container}>
      <table
        className={`${styles.table} ${showOldValueColumn ? styles.comparisonTable : ''}`.trim()}
      >
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>
              <div className={styles.thContent}>Property</div>
            </th>
            {showOldValueColumn && (
              <th className={styles.th}>
                <div className={styles.thContent}>Previous Parameters</div>
              </th>
            )}
            <th className={styles.th}>
              <div className={styles.thContent}>
                {showOldValueColumn ? 'Updated Parameters' : 'Value'}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {rowsToRender.map((row, idx) => (
            <tr key={row.label || idx} className={styles.tableRow}>
              <td className={styles.tdLabel}>{row.label}</td>
              {showOldValueColumn && <td className={styles.td}>{row.previousDisplayValue}</td>}
              <td className={`${styles.td} ${row.hasChanged ? styles.changed : ''}`.trim()}>
                {showOldValueColumn && !row.hasChanged ? '-' : row.displayValue}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShowAdditionalParametersPreview;
